import React from 'react';

const GameSetupOverlay = ({ onSelectServer, onClose, opponentName }) => {
  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white p-6 rounded-lg shadow-xl max-w-sm w-full">
        <h2 className="text-xl font-bold mb-4 text-center">Who serves first?</h2>
        <p className="mb-4 text-center">Who is serving first in this set against <span className="font-semibold">{opponentName}</span>?</p>
        <div className="flex justify-around">
          <button
            onClick={() => { onSelectServer('me'); onClose(); }}
            className="bg-green-500 text-white px-4 py-2 rounded-md hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-opacity-50"
          >
            Me
          </button>
          <button
            onClick={() => { onSelectServer('opponent'); onClose(); }}
            className="bg-yellow-500 text-white px-4 py-2 rounded-md hover:bg-yellow-600 focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:ring-opacity-50"
          >
            Opponent
          </button>
        </div>
      </div>
    </div>
  );
};

export default GameSetupOverlay;


